/* One-at-a-time video carousel: arrow navigation, wrap-around, and an
   auto-advance timer that only runs while the carousel is on screen and
   not being hovered, focused, or touched. */
if (!customElements.get('video-carousel')) {
  customElements.define(
    'video-carousel',
    class VideoCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.track = this.querySelector('[data-carousel-track]');
        if (!this.track) return;
        this.initialized = true;

        this.reduceMotion =
          window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.interval = parseInt(this.dataset.interval, 10) || 5000;
        this.autoEnabled = this.dataset.autoplay === 'true' && !this.reduceMotion;
        this.paused = false;
        this.visible = false;

        this.querySelector('[data-carousel-prev]')?.addEventListener('click', () => {
          this.step(-1);
          this.restartTimer();
        });
        this.querySelector('[data-carousel-next]')?.addEventListener('click', () => {
          this.step(1);
          this.restartTimer();
        });

        ['pointerenter', 'focusin', 'touchstart'].forEach((type) =>
          this.addEventListener(type, () => {
            this.paused = true;
          }, { passive: true })
        );
        ['pointerleave', 'focusout'].forEach((type) =>
          this.addEventListener(type, () => {
            this.paused = false;
          })
        );

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(
            ([entry]) => {
              this.visible = entry.isIntersecting;
            },
            { threshold: 0.35 }
          );
          this.io.observe(this);
        } else {
          this.visible = true;
        }

        this.restartTimer();
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        if (this.io) this.io.disconnect();
      }

      restartTimer() {
        clearInterval(this.timer);
        if (!this.autoEnabled) return;
        this.timer = setInterval(() => {
          if (this.visible && !this.paused && !document.hidden) this.step(1);
        }, this.interval);
      }

      slideCount() {
        return this.track.children.length;
      }

      currentIndex() {
        const width = this.track.clientWidth;
        return width ? Math.round(this.track.scrollLeft / width) : 0;
      }

      step(dir) {
        const count = this.slideCount();
        if (!count) return;
        const next = (this.currentIndex() + dir + count) % count;
        this.track.scrollTo({
          left: next * this.track.clientWidth,
          behavior: this.reduceMotion ? 'auto' : 'smooth',
        });
      }
    }
  );
}

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('video-carousel').forEach((el) => el.connectedCallback());
});
